window.Acompanhamento = Backbone.Model.extend({

});

window.Acompanhamentos = Backbone.Collection.extend({
    model: Acompanhamento
});